// extracted by mini-css-extract-plugin
module.exports = {"marker":"properties_search_map_marker__2PCIq","markerContent":"properties_search_map_markerContent__2Ko-g"};